/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEducation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2.882 22.236 8 19 9.618v9.103l-7 2.333-7-2.333V9.618L1.764 8zm5 7.736-5 2.5-5-2.5v6.661l5 1.667 5-1.667zm-5-5.5L6.237 8 12 10.881 17.763 8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEducation as Education };
